import React, { useContext } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

import {
  UilCreateDashboard,
  UilUser,
  UilShieldCheck,
  UilUserLocation,
  UilShoppingCart,
  UilInvoice,
  UilWallet,
  UilSignout,
  UilCreditCard,
  UilBill,
  UilCommentAltEdit,
  UilTruck,
} from "@iconscout/react-unicons";

import { UserContext } from "../context/user.context";

import NavData from "../utils/Data/UserNavData.json";
import UiMosque from "../utils/icons/UiMosque";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const UserLayout = () => {
  const { currentUser } = useContext(UserContext);
  const loc = useLocation();

  return (
    <div className="">
      <header>
        <div className="bg-pagePattern bg-center">
          <div className="flex mx-auto max-w-screen-lg text-center justify-center items-center h-32  ">
            <label className="text-7xl text-textWhite font-medium  ">
              {loc.state?.PageTitle == null
                ? "Missing Title"
                : loc.state.PageTitle}
            </label>
          </div>
        </div>
      </header>

      <main className="flex flex-col mb-28 mx-auto max-w-screen-lg lg:pl-5 lg:pr-5">
        <div className="flex flex-col md:flex-row mt-4 gap-5">
          <div
            className="hidden md:flex flex-col p-4 w-64 border border-navbarBorder bg-navbarBackground rounded-lg
                          justify-start items-center h-auto"
          >
            <label className="font-medium font-poppins text-base text-navarbarText text-center">
              Welcome {!currentUser?.isloggedIn ? "" : currentUser?.outletName}
            </label>

            <div className="w-[188px] h-[1px] mt-4 bg-secondaryHover text-center"></div>

            <div className="flex flex-col gap-4 mt-4 justify-start items-start w-52 ">
              {NavData.filter((item) => item.active).map((item) => {
                const key = item.id ?? item.path ?? item.title;
                return (
                  <NavLink
                    key={key}
                    to={`../user/${item.path}`}
                    state={{ PageTitle: item.title }}
                    className={classNames(
                      item.active ? "text-primaryHover" : "text-primary",
                      "flex flex-row items-center px-4 py-1 text-base gap-2 font-poppins hover:text-primary"
                    )}
                  >
                    {item.title === "Dashboard" ? (
                      <UilCreateDashboard className="text-primary" />
                    ) : item.title === "Profile" ? (
                      <UilUser className="text-primary" />
                    ) : item.title === "Address Book" ? (
                      <UilUserLocation className="text-primary" />
                    ) : item.title === "Security" ? (
                      <UilShieldCheck className="text-primary" />
                    ) : item.title === "Zulal Wallet" ? (
                      <UilWallet className="text-primary" />
                    ) : item.title === "Orders" ? (
                      <UilShoppingCart className="text-primary" />
                    ) : item.title === "Partial Deliveries" ? (
                      <UilTruck className="text-primary" />
                    ) : item.title === "Invoices" ? (
                      <UilInvoice className="text-primary" />
                    ) : item.title === "Payments" ? (
                      <UilBill className="text-primary" />
                    ) : item.title === "Mosque Orders" ? (
                      <UiMosque
                        className="text-primary"
                        fillColor={`#3F95A9`}
                      />
                    ) : item.title === "Partners Card" ? (
                      <UilCreditCard className="text-primary" />
                    ) : item.title === "Suggestion / Complaints" ? (
                      <UilCommentAltEdit className="text-primary" />
                    ) : item.title === "Log Out" ? (
                      <UilSignout className="text-primary" />
                    ) : (
                      ""
                    )}
                    {item.title}
                  </NavLink>
                );
              })}
            </div>
          </div>
          <div className="items-start w-full">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
};
